


























import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
let uniqueId = 0;

@Component
export default class extends Vue {
  public $refs!: {
    input: HTMLDivElement[];
    btn: HTMLDivElement;
  };

  @Prop({
    default: () => {
      return `radio-input-${uniqueId++}`;
    },
  })
  public idPrefix!: string;

  @Prop({
    default: () => {
      return [];
    },
  })
  public options!: string[];

  @Prop({ default: true })
  public active!: boolean;

  @Prop({ default: true })
  public activated!: boolean;

  @Prop({ default: 0 })
  public value!: number;

  private localValue = 0;
  private inputWidth = 0;
  private startPos = 0;
  private curPos = 0;
  private manualOffset = 0;
  private isMoving = false;

  created() {
    this.localValue = this.value;
  }

  public mounted() {
    if (document) {
      this.resized = this.resized.bind(this);
      this.$nextTick(() => {
        this.resized();
      });
      window.addEventListener('resize', this.resized);

      this.onTouchStart = this.onTouchStart.bind(this);
      this.onTouchEnd = this.onTouchEnd.bind(this);
      this.onTouchMove = this.onTouchMove.bind(this);

      document.addEventListener('touchstart', this.onTouchStart);
      document.addEventListener('touchend', this.onTouchEnd);
      document.addEventListener('touchmove', this.onTouchMove);
      document.addEventListener('mousedown', this.onTouchStart);
      document.addEventListener('mousemove', this.onTouchMove);
      document.addEventListener('mouseup', this.onTouchEnd);
      document.addEventListener('mouseenter', this.onTouchEnd);
    }
  }

  public beforeDestroy() {
    if (document) {
      window.removeEventListener('resize', this.resized);
      document.removeEventListener('touchstart', this.onTouchStart);
      document.removeEventListener('touchend', this.onTouchEnd);
      document.removeEventListener('touchmove', this.onTouchMove);
      document.removeEventListener('mousedown', this.onTouchStart);
      document.removeEventListener('mousemove', this.onTouchMove);
      document.removeEventListener('mouseup', this.onTouchEnd);
      document.removeEventListener('mouseenter', this.onTouchEnd);
    }
  }

  private onMove(offset: number): void {
    this.manualOffset = offset;
  }

  private onMoveEnd(): void {
    const totalOffset = this.carretOffset - this.manualOffset;
    const value = Math.floor(totalOffset / this.inputWidth);
    this.localValue = value;
    this.changed();
    this.manualOffset = 0;
  }

  private onTouchStart(evt: TouchEvent | MouseEvent) {
    this.startPos =
      evt instanceof TouchEvent ? evt.touches[0].pageX : evt.pageX;
    if (!evt.target || evt.target !== this.$refs.btn) {
      return;
    }

    evt.preventDefault();
    this.isMoving = true;
  }
  private onTouchEnd(evt: TouchEvent | MouseEvent) {
    if (this.isMoving) {
      evt.preventDefault();
      this.isMoving = false;
      this.onMoveEnd();
      return;
    }

    if (!evt.target || evt.target !== this.$refs.btn) {
      return;
    }
  }

  private onTouchMove(evt: TouchEvent | MouseEvent) {
    this.curPos = evt instanceof TouchEvent ? evt.touches[0].pageX : evt.pageX;
    if (this.isMoving) {
      this.onMove(this.startPos - this.curPos);
    }
  }

  @Watch('value')
  private onValueChange() {
    this.localValue = this.value;
  }

  @Emit('change')
  private changed() {
    return this.localValue;
  }

  private resized() {
    this.inputWidth =
      this.$refs.input.length > 0 ? this.$refs.input[0].offsetWidth : 0;
  }

  private get carretOffset() {
    return (this.value - 0.5 + 1) * this.inputWidth;
  }

  private get offsetStyle() {
    let offset = this.carretOffset - this.manualOffset;
    const min = this.inputWidth / 2;
    const max = this.options.length * this.inputWidth - this.inputWidth / 2;
    offset = offset < min ? min : offset;
    offset = offset > max ? max : offset;
    return this.active ? { transform: `translateX(${offset}px)` } : {};
  }

  updated() {
    this.resized();
  }
}
